import { RefObject, useEffect, useState } from "react";

function useHasOverflow(ref: RefObject<HTMLElement>): boolean {
  const [hasOverflow, setHasOverflow] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      if (ref.current) {
        setHasOverflow(ref.current.scrollHeight > ref.current.clientHeight);
      }
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, [ref]);

  return hasOverflow;
}

export default useHasOverflow;
